import { bindable } from 'aurelia-framework';
import { ImportItemStatus } from './import-api';
import { ImportItem } from './import-item';

export class NoImportItemsView {
	@bindable items: ImportItem[];
	@bindable filter: ImportItemStatus;
	@bindable importableCount: number;
	@bindable errorCount: number;
	@bindable warningCount: number;
}
